import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Eye = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="8" cy="8" r="2" stroke={color} />
      <path
        d="M8 3C12 3 14 6.33333 14.5 8C14 9.66667 12 13 8 13C4 13 2 9.66667 1.5 8C2 6.33333 4 3 8 3Z"
        stroke={color}
      />
    </svg>
  ),
)

Eye.displayName = 'Eye'

Eye.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Eye
